import { OnInit, EventEmitter } from '@angular/core';
var PinButtonComponent = /** @class */ (function () {
    function PinButtonComponent() {
        this.selectable = false;
        this.size = 'medium';
        this.type = 'default';
        this.direction = 'column';
        this._selected = false;
        this.disabled = false;
        this.selectedChange = new EventEmitter();
    }
    Object.defineProperty(PinButtonComponent.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (value) {
            this._selected = value;
            this.selectedChange = new EventEmitter();
        },
        enumerable: true,
        configurable: true
    });
    PinButtonComponent.prototype.ngOnInit = function () {
    };
    PinButtonComponent.prototype.handleClick = function () {
        if (this.disabled) {
            return;
        }
        if (this.selectable) {
            this.selected = !this.selected;
        }
    };
    return PinButtonComponent;
}());
export { PinButtonComponent };
